import * as Yup from 'yup';

// for the UW form, we use validation to determine if a user has submitted a wrong answer (an answer that goes against underwriting rules).
// ex. user submits false for isPrimaryHome question, that will make the offer ineligible for home.
// the validation will run and return an error object with the node, which will be used in cannot-offer-modal.js to determine eligibility
// at that modal, the user is given the option to drop home/auto, setting ineligibleForHomeDueToUWSelfReport/ineligibleForAutoDueToUWSelfReport to true
// and skip validation to submit and recalc so that the backend UW rules can drop the ineligible policy type

const baseFLSchema = Yup.object().shape({
  signedPropertyUWAttestation: Yup.boolean().oneOf([true], 'Agent must check attestation checkbox').required()
});

const homeFLSchema = Yup.object().shape({
  home: Yup.object().shape({
    isPrimaryHome: Yup.string()
      .required()
      .test('isPrimaryHome', (value) => value === 'true'),
    hasTrampolinesOrSkateBoardRampEtc: Yup.string()
      .required()
      .test('hasTrampolinesOrSkateBoardRampEtc', (value) => value === 'false'),
    hadRentedMultTimesOrFullTimeOneTenant: Yup.string()
      .required()
      .test('hadRentedMultTimesOrFullTimeOneTenant', (value) => value === 'false'),
    isOwnedByCorpOrPartnershipEtc: Yup.string()
      .required()
      .test('isOwnedByCorpOrPartnershipEtc', (value) => value === 'false'),
    isInForeclosure: Yup.string()
      .required()
      .test('isInForeclosure', (value) => value === 'false'),
    hasMoreThan2Mortgages: Yup.string()
      .required()
      .test('hasMoreThan2Mortgages', (value) => value === 'false'),
    hadPriorLossIn5Years: Yup.string()
      .required()
      .test('hadPriorLossIn5Years', (value) => value === 'false'),
    isPriorPolicyCancelledOrNonRenewed: Yup.string()
      .required()
      .test('isPriorPolicyCancelledOrNonRenewed', (value) => value === 'false'),
    isIneligibleDogBreed: Yup.string()
      .required()
      .test('isIneligibleDogBreed', (value) => value === 'false'),
    hasExoticOrNonDomesticatedEtcAnimals: Yup.string()
      .required()
      .test('hasExoticOrNonDomesticatedEtcAnimals', (value) => value === 'false'),
    hasPetBiteHistoryOrViciousBehavior: Yup.string()
      .required()
      .test('hasPetBiteHistoryOrViciousBehavior', (value) => value === 'false'),
    excludeWindCoverage: Yup.string()
      .required()
      .test('excludeWindCoverage', (value) => value === 'false'),
    excludeContentCoverage: Yup.string()
      .required()
      .test('excludeContentCoverage', (value) => value === 'false'),
    includeSinkholeCoverage: Yup.string()
      .required()
      .test('includeSinkholeCoverage', (value) => value === 'false'),
    hadSinkholeActivityOrIsAdjacentToSinkholes: Yup.string()
      .required()
      .test('hadSinkholeActivityOrIsAdjacentToSinkholes', (value) => value === 'false'),
    hasFlatRoofs: Yup.string()
      .required()
      .test('hasFlatRoofs', (value) => value === 'false'),
    isMobileOrPrefabricatedEtc: Yup.string()
      .required()
      .test('isMobileOrPrefabricatedEtc', (value) => value === 'false'),
    hasRecalledConstructionMaterials: Yup.string()
      .required()
      .test('hasRecalledConstructionMaterials', (value) => value === 'false'),
    isWaterHeaterAgeGreaterThan15Years: Yup.string()
      .required()
      .test('isWaterHeaterAgeGreaterThan15Years', (value) => value === 'false'),
    runDayCareOutOfMyHome: Yup.string()
      .required()
      .test('runDayCareOutOfMyHome', (value) => value === 'false'),
    hasCommercialOccupation: Yup.string()
      .required()
      .test('hasCommercialOccupation', (value) => value === 'false'),
    hasInsuranceCurrently: Yup.string()
      .required()
      .test('hasInsuranceCurrently', (value) => value === 'true')
  })
});

const autoFLSchema = Yup.object().shape({
  auto: Yup.object()
    .shape({
      needSR22: Yup.string()
        .required()
        .test('needSR22', (value) => value === 'false'),
      excludeBICoverage: Yup.string()
        .required()
        .test('excludeBICoverage', (value) => value === 'false')
    })
    .nullable()
});

export const FLValidationSchema = (selectedOption) => {
  let schema = baseFLSchema;
  if (selectedOption.includes('H')) {
    schema = schema.concat(homeFLSchema);
  }
  if (selectedOption.includes('A')) {
    schema = schema.concat(autoFLSchema);
  }
  return schema;
};
